import { FormIncrementButton } from "@/forms-design-system/FormCounter/FormIncrementButton";
import { useTranslate } from "@/hooks/useTranslate";

export type ThemedAddItemButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const ThemedAddItemButton = ({ onClick }: ThemedAddItemButtonProps) => {
  const { t } = useTranslate();

  return (
    <FormIncrementButton
      sx={{
        minWidth: { xs: 0, md: 140 },
      }}
      onClick={onClick}
      data-test="themed-add-item-button"
    >
      {t("ticketing", "add")}
    </FormIncrementButton>
  );
};
